import gql from "graphql-tag";

// Staff props
const FluidStaffProps = gql`
	fragment FluidStaffProps on Staff {
		id
		surname
		first_name
		middle_name
		email
		type {
			id
			name
		}
		designation {
			id
			name
		}
		department {
			id
			name
		}
		image
	}
`;

const FluidProps = gql`
	fragment FluidProps on Fluid {
		id
		amountTaken
		offered
		datetime
		author {
			...FluidStaffProps
		}
	}
	${FluidStaffProps}
`;

const LIST = gql`
	query GetPatientFluidInTakes($id: ID!) {
		GetFluidIntakes(id: $id) {
			docs {
				...FluidProps
			}
		}
	}
	${FluidProps}
`;

const CREATE = gql`
	mutation NewFluidIntake($model: InputFluid!) {
		NewFluidIntake(model: $model) {
			message
			doc {
				...FluidProps
			}
		}
	}
	${FluidProps}
`;
export { LIST, CREATE };
